import { FC } from "react";
import { Link } from "react-router-dom";

export const Header: FC = () => {
  return (
    <header>
      <div>
        <Link
          to="/"
          className="flex items-center gap-2 text-neutral-900 font-bold"
        >
        </Link>
      </div>
    </header>
  );
};
